<template>
    <div id="app" class="container">
        <header-n/>
        <router-view/>
    </div>
</template>

<script>
    import HeaderN from './components/pic_bn/HeaderN'

    export default {
        name: 'App',
        components: {
            HeaderN
        }
    }
</script>

<style>
    #pl {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: white;
        opacity: 0.7; /* Полупрозрачный фон */
        z-index: 100500;
    }

    #pl .sp {
        /*width: 100%;*/
        /*height: 100px;*/
        position: absolute;
        top: 50%;
        bottom: 50%;
        left: 0;
        right: 0;
        margin: auto;
        opacity: 1; /* Полупрозрачный фон */
    }

    /* Анимации появления и исчезновения могут иметь    */
    /* различные продолжительности и функции плавности. */
    .slide-fade-enter-active {
        transition: all 0.3s ease-out;
    }

    .slide-fade-leave-active {
        transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter-from,
    .slide-fade-leave-to {
        transform: translateX(20px);
        opacity: 0;
    }
</style>
